import _ from 'lodash-es';
import QueryRule from '~/scripts/services/model/query-rule';
import QueryVariable from '~/scripts/services/model/query-variable';
import { defaultDateRange, fields } from '~/components/query/query-rule/query-rule.controller';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';
import QueryWhereNode from '~/scripts/services/model/query-where-node';
import { operators, types } from '../query-editor/query-editor.controller';
import templateModalQueryMultipleFilterValues from './modal/modal-query-multiple-filter-values.html';
import ModalQueryMultipleFilterValuesController from './modal/modal-query-multiple-filter-values.controller';
import { rights } from '~/components/droit/droit.controller';

export default class QueryRuleValueController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor($scope, $timeout, $translate, $uibModal) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;

		/** @type {Function | undefined} */
		this.change = undefined;

		/** @type {?import('../query-builder-children/query-builder-children.controller').default} */
		this.children = null;

		this.datePickerOptions = undefined;

		this.dateUnits = [
			'second',
			'minute',
			'hour',
			'day',
			'week',
			'month',
			'quarter',
			'year',
		];

		/** @type {'kid'|'isa'|'file'|'repre'|'attribut'|'ref_propri'|'droit'} */
		this.field = 'kid';

		this.fields = fields;

		/** @type {{id: any, name: string}[]} */
		this.fieldValues = [];

		this.isArray = Array.isArray;

		/** @type {import('angular').INgModelController | undefined} */
		this.ngModelCtrl = undefined;

		this.operators = operators;

		this.options = {};

		/** @type {import('@knitiv/api-client-javascript').KNode | ?string | undefined} */
		this.order = undefined;

		/** @type {string} */
		this.placeholder = '';

		/** @type {boolean} */
		this.required = false;

		this.rights = rights;

		/** @type {QueryRule | QueryWhereRule | QueryVariable | undefined} */
		this.rule = undefined;

		this.tright = {
			delete: false,
			modify: false,
			create: false,
			read:   true,
		};

		this.type = undefined;

		this.types = types;

		/** @type {any} */
		this.value = undefined;
	}

	async openModalMultipleFilterValues() {
		const newValue = await this.$uibModal.open({
			template:     templateModalQueryMultipleFilterValues,
			controller:   ModalQueryMultipleFilterValuesController,
			controllerAs: '$ctrl',
			resolve:      {
				options: () => this.options,
				rule:    () => this.rule,
				value:   () => this.value,
				node:    () => this.children?.group?.node,
			},
		}).result;
		this.$timeout(() => {
			if (!Array.isArray(this.value)) {
				this.value = [];
			}
			_.extend(this.value, newValue);
			// this.value = newValue;
			if (this.change) {
				this.change(new Event('change'));
			}
		});
	}

	/**
	 * @param {boolean} rangeFlag
	 */
	setDateRange(rangeFlag) {
		if (rangeFlag) {
			if (!this.value?.unit || this.value?.duration === undefined) {
				this.$timeout(() => {
					this.value = defaultDateRange;
				});
			}
		}
		else {
			this.$timeout(() => {
				if (this.value?.unit) {
					this.value = undefined;
				}
			});
		}
	}

	updateDroit() {
		if (typeof this.value !== 'object' || this.value.kright === undefined) {
			this.value = {
				kright: 0,
			};
		}
		else {
			this.value.kright = 0;
		}
		if (this.tright) {
			for (const r of this.rights) {
				if (this.tright[r.id] === true) {
					this.value.kright += r.value;
				}
			}
		}
	}

	/**
	 * @param {any} changes
	 */
	$onChanges(changes) {
		if (
			changes.field
			&& this.rule instanceof QueryWhereRule
			&& changes.field.currentValue !== changes.field.previousValue
			&& this.children?.group?.node
		) {
			if (!_.isEmpty(changes.field.previousValue)) {
				this.value = undefined;
			}
			this.placeholder = this.$translate.instant(`query.field.${this.field}`);
			const { node } = this.children.group;

			switch (this.field) {
			case 'kid': {
				if (node instanceof QueryWhereNode) {
					this.order = node.kid;
					this.type = node.type;
					this.placeholder = node.name ?? '';
				}
				break;
			}
			case 'repre': {
				this.order = undefined;
				if (node instanceof QueryWhereNode) {
					this.type = node.type;
				}
				this.placeholder = this.$translate.instant('common.repre');
				break;
			}
			case 'isa': {
				this.order = 'CLASS';
				this.type = 'K_NODE;STRING';
				this.placeholder = this.$translate.instant('common.class');
				break;
			}
			case 'attribut': {
				this.order = undefined;
				this.type = 'K_NODE;STRING';
				break;
			}
			case 'file': {
				this.order = undefined;
				this.type = 'K_NODE;BOOL';
				this.fieldValues = fields.find(f => f.id === this.field)?.values ?? [];
				break;
			}
			case 'ref_propri': {
				this.order = 'K_NODE;KPROFIL';
				this.type = 'K_NODE;STRING';
				this.placeholder = this.$translate.instant('right.profil');
				break;
			}
			case 'droit': {
				this.order = undefined;
				this.type = undefined;
				this.updateDroit()
				break;
			}
			default: {
				this.order = undefined;
				this.type = undefined;
			}
			}
			this.$timeout(() => {
				this.$scope.$apply();
			});
		}
	}

	$doCheck() {
		if (this.rule instanceof QueryWhereRule && this.rule.field) {
			// const node = this.rule.getNode();
			// this.order = node.kid;
			// this.type = this.rule.field === 'kid' ? node.type : fields[this.rule.field].type;
		}
		else if (this.rule) {
			this.order = 'isa' in this.rule ? this.rule.isa : this.rule.field;
			this.type = this.rule.type;
		}
	}

	$onInit() {
		this.datePickerOptions = {
			allowInput:   true,
			dateFormat:   'd/m/Y',
			displayInput: true,
			enableTime:   false,
			placeholder:  this.$translate.instant('common.date'),
			static:       false,
			time_24hr:    true,
		};
	}
}
